import { createSlice } from "@reduxjs/toolkit";

const tiktokSlice = createSlice({
    name: "tiktok",
    initialState: {
        tiktoks: {
            listData: {
                current: null,
                previous: null,
            },
            isFetching: false,
            error: false,
        },
    },
    reducers: {
        getDataTiktokStart: (state) => {
            state.tiktoks.isFetching = true;
        },
        getDataTiktokSuccess: (state, action) => {
            state.tiktoks.isFetching = false;
            state.tiktoks.listData = action.payload; // { current, previous }
            state.tiktoks.error = false;
        },
        getDataTiktokFailed: (state) => {
            state.tiktoks.isFetching = false;
            state.tiktoks.error = true;
        },
    },
});

export const {
    getDataTiktokStart,
    getDataTiktokSuccess,
    getDataTiktokFailed,
} = tiktokSlice.actions;

export default tiktokSlice.reducer;

